'use strict';

/**
 *
 * @name: nnModules
 *
 */
import DirectiveTemplate from './nn-newsletter.directive.html';
import './nn-newsletter.directive.scss';

function NnNewsletterDirective () {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: true,
    template: DirectiveTemplate,
    controller: NnNewsletterDirectiveController
  };
}

function NnNewsletterDirectiveController ($scope, apiNewsletterService) {
  'ngInject';

  /*
   *
   * @CONFIG
   *
   */

  $scope.recieveNewsletter = false
  $scope.recieveOffers = false
  $scope.email = ''
  $scope.toast = {
    success: true,
    message: ''
  }
  $scope.required = false


  /*
   *
   * @PUBLIC
   *
   */

  $scope.onSubscribe = () => {
    if (!$scope.recieveNewsletter) {
      $scope.required = true
      return
    }

    $scope.required = false

    const payload = {
      email: $scope.email,
      offers: $scope.recieveOffers
    }

    apiNewsletterService.subscribe(payload).then(
      res => {
        if (res.data.subscribed) {
          $scope.toast.message = 'SUCCESFULLY_SUBSCRIBED'
          $scope.toast.success = true
          $scope.email = ''
          $scope.recieveOffers = false
          $scope.recieveNewsletter = false
        } else {
          $scope.toast.message = 'ALREADY_SUBSCRIBED'
          $scope.toast.success = false
        }
        setTimeout(() => {
          $scope.toast.message = ''
        }, 5000)
      },
      () => {
        $scope.toast.message = 'SYSTEM_ERROR'
        $scope.toast.success = false
      }
    )
  }


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */

  $scope.$watch('recieveNewsletter', val => {
    if (val) {
      $scope.required = false
    }
  })

}

export default NnNewsletterDirective



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-newsletter/nn-newsletter.directive.js